import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";
import hubspotLogo from '../img/hubspot.png';

const Home = () => {
    const { logOut, user } = useUserAuth();
    const navigate = useNavigate();
    const install_url = "https://app-eu1.hubspot.com/oauth/authorize?client_id=e7a994d6-e98f-45f1-8e86-d7e0701da522&redirect_uri=https://tools.erabond.io/auth-hubspot&scope=crm.schemas.companies.write%20crm.schemas.quotes.read%20crm.schemas.contacts.write%20crm.objects.line_items.read%20crm.schemas.deals.read%20crm.objects.line_items.write%20crm.schemas.deals.write%20crm.schemas.line_items.read%20automation%20actions%20crm.objects.owners.read%20tickets%20crm.objects.contacts.write%20e-commerce%20crm.objects.marketing_events.read%20crm.objects.marketing_events.write%20crm.schemas.custom.read%20sales-email-read%20crm.objects.companies.write%20crm.lists.write%20crm.objects.companies.read%20crm.lists.read%20crm.objects.deals.read%20crm.schemas.contacts.read%20crm.objects.deals.write%20crm.objects.quotes.write%20crm.objects.contacts.read%20crm.schemas.companies.read%20crm.objects.quotes.read"

    const handleLogout = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            console.log(error.message);
        }
    };
    return (
        <>
            <div style={{backgroundColor:"white", borderRadius: "8px"}}>
                <div style={{display: "flex", flexDirection: "column", color: "black", padding: "48px"}}>
                    <img src={hubspotLogo} width={200} style={{textAlign: "center", marginBottom: "24px", alignContent: "center"}}></img>
                    <h3>Connect Your HubSpot Account</h3>
                    <p>In order to access your HubSpot data, we will need you to connect the relevant permissions.</p>
                    <Button style={{backgroundColor: "#825ee7", color: "white"}} href={install_url} variant="primary">Connect HubSpot</Button>
                </div>
            </div>

        </>
    );
};

export default Home;